import { render, staticRenderFns } from "./EntidadeFormDialog.vue?vue&type=template&id=5108b5c5&scoped=true&"
import script from "./EntidadeFormDialog.vue?vue&type=script&lang=js&"
export * from "./EntidadeFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./EntidadeFormDialog.vue?vue&type=style&index=0&id=5108b5c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108b5c5",
  null
  
)

export default component.exports